// extracted by mini-css-extract-plugin
export default {"bindingDialog":"BindingDialog_bindingDialog__CZrKY","backdrop":"BindingDialog_backdrop__V4TSI","text":"BindingDialog_text__bgpEr","button":"BindingDialog_button__pnYBj"};